<template>
  <section class="section alt">
    <div class="container">
      <SectionHead eyebrow="WHO WE ARE">
        "共同体"不是口号，是<span class="gradient-text">三层承诺</span>
      </SectionHead>
      <p class="section-copy who-copy">
        易隆创不是一个简单的交易平台，而是一个让所有参与者共同生长的生态组织。三层内涵，支撑起这个"共同体"。
      </p>
      <div class="grid-3 who-cards">
        <article v-for="c in cards" :key="c.title" class="card who-card reveal">
          <div class="who-card-icon" v-html="c.icon"></div>
          <h3>{{ c.title }}</h3>
          <p class="who-card-desc">{{ c.desc }}</p>
          <div class="who-card-foot">
            <small>对您意味着</small>
            <p>{{ c.means }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHead from '@/components/display/SectionHead.vue';

export default {
  name: 'HomeWhoWeAre',
  components: { SectionHead },
  data() {
    return {
      cards: [
        {
          title: '利益共同体',
          desc: '资源共享、风险共担、利润分配透明，让每一份投入都有对等的回报。',
          means: '利润你拿大头，平台只收服务费，做大蛋糕再分蛋糕。',
          icon:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>'
        },
        {
          title: '能力共同体',
          desc: '技术、方案、资质、交付能力全链路打通，补短板、拉长板，让每一家伙伴都变强。',
          means: '你的短板由生态补齐，专注你最擅长的事即可。',
          icon:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>'
        },
        {
          title: '命运共同体',
          desc: '长期主义、生态共建、品牌共荣，一起把易隆创打造成新基建的基础设施。',
          means: '一次加入，长期受益，生态成长就是你的成长。',
          icon:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>'
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.who-copy {
  max-width: 1100px;
  text-align: center;
  margin: -30px auto 40px;
}

.who-cards {
  gap: 24px;
  margin-top: 14px;
}

.who-card {
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 36px 28px;
  gap: 8px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  backdrop-filter: blur(6px);
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(131, 230, 255, 0.45);
    transform: translateY(-6px) !important;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);
  }
}

.who-card-icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(131, 230, 255, 0.35);
  border-radius: 50%;
  font-size: 26px;
  color: #83e6ff;
  margin: 0 auto 10px;
  background: radial-gradient(circle at 30% 30%, rgba(131, 230, 255, 0.18), transparent 70%);

  ::v-deep svg {
    width: 28px;
    height: 28px;
    display: block;
  }
}

.who-card h3 {
  font-size: 24px;
  color: #fff;
  margin: 6px 0 4px;
  letter-spacing: 0.01em;
}

.who-card-desc {
  font-size: 15px;
  color: #a9b4cb;
  line-height: 1.6;
  min-height: 48px;
}

.who-card-foot {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  text-align: left;

  small {
    display: block;
    font-size: 12px;
    color: #7d8aa5;
    letter-spacing: 0.08em;
    margin-bottom: 6px;
  }

  p {
    font-size: 15px;
    color: #83e6ff;
    line-height: 1.6;
  }
}

@media (max-width: 760px) {
  .who-cards {
    grid-template-columns: 1fr;
  }
  .who-copy {
    white-space: normal;
  }
}
</style>
